import React, { useState } from "react";
import { FriendItem } from "./friend-item";
import { useSignals } from "@preact/signals-react/runtime";
import { signal } from "@preact/signals-react";
import { showMessageBox } from "@/components/blocks/message-box";
import { graphQLClient } from "@/lib/client-graphql";
import { useTranslation } from "@/providers/language-provider";
import { useChats } from "@/providers/chat-provider";
import { ScrollArea } from "@/components/ui/scroll-area";
import {
  Sheet,
  SheetContent,
  SheetHeader,
  SheetTitle,
} from "@/components/ui/sheet";
import { ButtonSubmit } from "@/components/blocks/button-submit";
import { UserMinus } from "lucide-react";

export const selectedChat = signal<any>(null);
export const selectedFriend = signal<any>(null);
export const deleteFriendHandler = signal(async () => {});

export const FriendList = () => {
  useSignals();
  const { t } = useTranslation();
  const { chats, fetchFriends } = useChats();
  const [isOpen, setIsOpen] = useState(false);
  const [isLoading, setIsLoading] = React.useState<boolean>(false);

  React.useEffect(() => {
    deleteFriendHandler.value = handleDeleteFriend;
  }, []);

  React.useEffect(() => {
    fetchFriends();
    // 30초마다 친구 목록을 업데이트한다.
    const interval = setInterval(() => {
      fetchFriends();
    }, 30000);
    return () => clearInterval(interval);
  }, [fetchFriends]);

  const selectFriend = (chat: any) => {
    selectedChat.value = chat;
    selectedFriend.value = chat?.friend;
  };

  const handleSelectFriend = (chat: any) => {
    selectFriend(chat);
    setIsOpen(true);
  };

  const handleDeleteFriend = async () => {
    const choice = await showMessageBox({
      type: "Confirm_Alert",
      title: t("RemoveFriend"),
      description: t("RemoveFriendDesc"),
    });
    if (choice === "Yes") {
      try {
        setIsLoading(true);
        const data = await graphQLClient.deleteChat({
          chatId: selectedChat.value._id,
        });
        console.log(data);
        selectFriend(null);
        // await fetchChats();
        setIsLoading(false);
        setIsOpen(false);
      } catch (error) {
        console.error(error);
      }
    }
  };

  return (
    <div className="relative h-full w-full overflow-hidden border">
      <ScrollArea className="w-full h-full">
        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5 2xl:grid-cols-6 gap-4 p-4">
          {chats?.friends?.map((chat: any) => (
            <FriendItem
              key={chat._id}
              user={chat.friend}
              onClick={() => handleSelectFriend(chat)}
            />
          ))}
        </div>
      </ScrollArea>
      <Sheet open={isOpen} onOpenChange={setIsOpen}>
        {/* SheetTrigger 없이 사용 */}
        <SheetContent
          side="bottom"
          className="absolute" // 부모 내부에 가두기
        >
          <SheetHeader>
            <SheetTitle>
              {t("ManageFriend")} - {selectedFriend.value?.name}
            </SheetTitle>
          </SheetHeader>
          <div className="flex justify-end py-4">
            <ButtonSubmit
              size="sm"
              variant="destructive"
              onClick={handleDeleteFriend}
              isSubmitting={isLoading}
            >
              <UserMinus className="h-4 w-4 mr-1" />
              {t("Remove")}
            </ButtonSubmit>
          </div>
        </SheetContent>
      </Sheet>
    </div>
  );
};
